import "./PlaceholderByPage.scss";

import usersPNG from "../../assets/images/placeholder/users.png";
import placeholderBg from "../../assets/images/placeholder/placeholder_bg.png";

function Placeholder({ textMsg, pageName }) {
  return (
    <div
      className="placeholder-by-page"
      style={{ backgroundImage: `url(${placeholderBg})`, backgroundSize: "contain" }}
    >
      <h4 className="placeholder-by-page__title">{textMsg}</h4>
      <img alt={`no-results-${pageName}`} className="placeholder-by-page__image" src={usersPNG} />
    </div>
  );
}

export default Placeholder;
